import { APIv1 } from 'src/api'
import { call, put } from 'redux-saga/effects'

import notifyer from 'src/common/notifyer'
import { ITemplatePhrase } from 'src/store/reducers/template-phrases'
import { TEMPLATE_LIST_CHANGED } from 'src/store/types/templatePhrases'

const postNewTemplate = (template: ITemplatePhrase): Promise<any> => (
  APIv1.post('/admin/templates/create', { template: template.id, phrase: template.value })
)

export default function* createTemplate(action: any) {
  try {
    // @ts-ignore
    yield call(postNewTemplate, action.payload)
    notifyer.success(`Template "${action.payload.id}" added`)
    yield put({ type: TEMPLATE_LIST_CHANGED })
  } catch (e) {
    notifyer.error('Request failed - server error')
  }
}
